import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import Swal from "sweetalert2";
import { useAuth } from "../auth/AuthContext";
import Select from "../components/SelectScenarios";
import { SWEETALERT_THEME } from "../utils/sweetalert-theme";
// Ajusta si tu API devuelve otro shape
const DIET_FIELDS = [
  "CEREALS",
  "FISH",
  "FRUVEG",
  "PORK",
  "MILK",
  "OLSOIL",
  "EGGS",
  "PULSES",
  "REDMEAT",
  "ROOTS",
  "SUGAR",
  "POULTRY",
  "NUTS",
  "ANIMFAT",
  "BEVSPICES",
  "OTHER",
  "ALCOHOL",
];

const IRRIGATION_FIELDS = [
  "BEVSPICES",
  "OLSOIL",
  "CEREALS",
  "PULSES",
  "FIBERINDUS",
  "ROOTS",
  "FRUVEG",
  "SUGAR",
  "NUTS",
];

const IRRIGATION_LABELS = {
  BEVSPICES: "BEVSPICES (clove, pepper, tea, etc.)",
  OLSOIL: "OLSOIL (olive, rapeseed, sunflower, etc.)",
  CEREALS: "CEREALS (wheat, corn, rice, etc.)",
  PULSES: "PULSES (beans, peas, soyabean, etc.)",
  FIBERINDUS: "FIBERINDUS (abaca, jute, rubber, etc.)",
  ROOTS: "ROOTS (cassava, potato, yams, etc.)",
  FRUVEG: "FRUVEG (apple, onion, tomato, etc.)",
  SUGAR: "SUGAR (sugarbeet and sugarcane)",
  NUTS: "Nuts (nuts, groundnut, etc.)",
};

const infoText = "(2020 = 1)"

const LIVESTOCK_FIELDS = [
  { key: "BOVD_beef",         label: "Dairy Bovines – beef meat - "+infoText,        animal: "BOVD", product: "beef" },
  { key: "BOVD_milk",         label: "Dairy Bovines – milk - "+infoText,             animal: "BOVD", product: "milk" },
  { key: "BOVO_beef",         label: "Bovines – beef meat - "+infoText,              animal: "BOVO", product: "beef" },
  { key: "PIGS_pork",         label: "Pigs – pork meat - "+infoText,                 animal: "PIGS", product: "pork" },
  { key: "PTRB_chicken",      label: "Broilers – chicken meat - "+infoText,          animal: "PTRB", product: "chicken" },
  { key: "PTRH_eggs",         label: "Laying Hens – eggs - "+infoText,               animal: "PTRH", product: "eggs" },
  { key: "PTRX_chicken",      label: "Mixed Poultry – chicken meat - "+infoText,     animal: "PTRX", product: "chicken" },
  { key: "PTRX_eggs",         label: "Mixed Poultry – eggs - "+infoText,             animal: "PTRX", product: "eggs" },
  { key: "SGTD_milk",         label: "Dairy Sheep and Goats – milk - "+infoText,     animal: "SGTD", product: "milk" },
  { key: "SGTD_mutton_goat",  label: "Dairy Sheep and Goats – meat - "+infoText,    animal: "SGTD", product: "mutton_goat" },
  { key: "SGTO_mutton_goat",  label: "Sheep and Goats – meat - "+infoText,           animal: "SGTO", product: "mutton_goat" },
];

const CROP_INFO_TEXT = "Productivity Gap (0% = MAX Productivity)";

const CROP_FIELDS = [
  { key: "Barley",    label: "Barley - "+CROP_INFO_TEXT,          crop: "Barley",    defaultYield: 68 },
  { key: "coffee",    label: "Coffee - "+CROP_INFO_TEXT,          crop: "coffee",    defaultYield: 87 },
  { key: "Corn",      label: "Corn - "+CROP_INFO_TEXT,            crop: "Corn",      defaultYield: 72 },
  { key: "groundnut", label: "Groundnut - "+CROP_INFO_TEXT,       crop: "groundnut", defaultYield: 40 },
  { key: "Millet",    label: "Millet - "+CROP_INFO_TEXT,          crop: "Millet",    defaultYield: 51 },
  { key: "Rapeseed",  label: "Rapeseed - "+CROP_INFO_TEXT,        crop: "Rapeseed",  defaultYield: 52 },
  { key: "sesame",    label: "Sesame - "+CROP_INFO_TEXT,          crop: "sesame",    defaultYield: 41 },
  { key: "Sorghum",   label: "Sorghum - "+CROP_INFO_TEXT,         crop: "Sorghum",   defaultYield: 60 },
  { key: "soyabean",  label: "Soybean - "+CROP_INFO_TEXT,         crop: "soyabean",  defaultYield: 53 },
  { key: "sunflower", label: "Sunflower - "+CROP_INFO_TEXT,       crop: "sunflower", defaultYield: 73 },
  { key: "Teff",      label: "Teff - "+CROP_INFO_TEXT,            crop: "Teff",      defaultYield: 54 },
  { key: "Wheat",     label: "Wheat - "+CROP_INFO_TEXT,           crop: "Wheat",     defaultYield: 64 },
  { key: "All",       label: "All other crops - "+CROP_INFO_TEXT, crop: "All",       defaultYield: 55 },
];

const IMPLEMENTATION_TIMING = [
  { id: 1, name: "Linear" },
  { id: 2, name: "Delayed" },
  { id: 3, name: "Fast" },
  { id: 4, name: "Other" },
  { id: 5, name: "AfforTiming" },
];

// Coefficients per year [2020, 2025, 2030, 2035, 2040, 2045, 2050] for each implementation timing
const POPULATION_IMPL_COEFS = {
  Linear:     [0, 0.166667, 0.333333, 0.5,      0.666667, 0.833333, 1],
  Delayed:    [0, 0,        0.143333, 0.353333,  0.63,     0.973333, 1],
  Fast:       [0, 0.25,     0.5,      0.75,      1,        1,        1],
  AfforTiming:[0, 0.5,      0.666667, 0.833333,  1,        1,        1],
  Other:      [0, 0.166667, 0.333333, 0.5,       0.666667, 0.833333, 1],
};

const POPULATION_YEARS = [2020, 2025, 2030, 2035, 2040, 2045, 2050];
const POPULATION_VAL_2020 = 117.19; // Millones de habitantes (valor fijo 2020)
const URBAN_VAL_2020 = 20; // porcentaje de habitantes urbanos (valor fijo 2020)

export default function ScenariosPage({
  t = (k, o) => o?.defaultValue ?? k,
  Sidebar = null,
  FloatChat = null,
  onlyTab = null,
  hideTabsHeader = false,
  noTopMargin = false,
}) {
  const { authFetch, bootstrapping, pendingTask, pendingTaskState, startPendingTask, user } = useAuth();
  const authFetchRef = useRef(authFetch);

  useEffect(() => {
    authFetchRef.current = authFetch;
  }, [authFetch]);

  // ===== data backend (como jsonData de EJS) =====
  const [jsonData, setJsonData] = useState(null);
  const [customScenarios, setCustomScenarios] = useState([]); // ✅ DB scenarios
  const [country, setCountry] = useState(
    String(user?.country).trim().toUpperCase(),
  );

  // ===== impl timing =====
  const [implTiming, setImplTiming] = useState([]);
  const implOptions = implTiming.map((x) => x?.name).filter(Boolean);

  // ===== tabs =====
  const forcedTab = Number.isFinite(Number(onlyTab)) ? Number(onlyTab) : null;
  const urlParams = new URLSearchParams(window.location.search);
  const queryTab = Number(urlParams.get("tab")) || null;
  const [tab, setTabState] = useState(
    () => forcedTab || queryTab || Number(localStorage.getItem("scenarios_tab")) || 1
  ); // 1..5

  useEffect(() => {
    if (forcedTab && tab !== forcedTab) {
      setTabState(forcedTab);
    }
  }, [forcedTab, tab]);

  const setTab = (t) => {
    if (forcedTab) return;
    setTabState(t);
    localStorage.setItem("scenarios_tab", t);
  };

  // ===== UI =====
  const [loadingPage, setLoadingPage] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  // ==========================
  // Helpers: normalizaciones
  // ==========================
  function normalizeString(x) {
    return String(x ?? "").trim();
  }

  function formatProductName(value) {
    const str = String(value ?? "").trim();
    if (!str) return "";

    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/-/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  function ensureObjectConfig(config) {
    if (!config) return null;
    if (typeof config === "object") return config;
    if (typeof config === "string") {
      try {
        const parsed = JSON.parse(config);
        return parsed && typeof parsed === "object" ? parsed : null;
      } catch {
        return null;
      }
    }
    return null;
  }

  function extractProductsFromConfig(config) {
    const cfg = ensureObjectConfig(config);
    if (!cfg) return [];
    if (Array.isArray(cfg.products)) return cfg.products;
    // fallback por si viene anidado
    if (cfg.Imports && Array.isArray(cfg.Imports.products)) return cfg.Imports.products;
    if (cfg.Exports && Array.isArray(cfg.Exports.products)) return cfg.Exports.products;
    return [];
  }

  // ==========================
  // Refresh (re-cargar jsonData + customScenarios)
  // ==========================
  const refreshDefined = useCallback(async () => {
    const res = await authFetchRef.current("/api/pathways/definedscenarios", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || `Error ${res.status}`);

    const location = String(data?.location || country).trim().toUpperCase();
    setCountry(location);
    const payload = data?.jsonData?.[location] ?? null;
    setJsonData(normalizeScenarioData(payload));

    // ✅ depende de tu backend modificado
    setCustomScenarios(Array.isArray(data?.customScenarios) ? data.customScenarios : []);
  }, [country]);

  // ==========================
  // 1) LOAD jsonData + customScenarios
  // ==========================
  useEffect(() => {
    let alive = true;
    const controller = new AbortController();

    async function load() {
      try {
        setLoadingPage(true);
        setError("");
        if (bootstrapping) return;

        const res = await authFetchRef.current("/api/pathways/definedscenarios", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          signal: controller.signal,
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data?.error || `Error ${res.status}`);

        const location = String(data?.location || country).trim().toUpperCase();
        const payload = data?.jsonData?.[location] ?? null;
        const normalized = normalizeScenarioData(payload);

        if (!alive) return;
        setCountry(location);
        setJsonData(normalized);
        setCustomScenarios(Array.isArray(data?.customScenarios) ? data.customScenarios : []);
      } catch (e) {
        if (e?.name !== "AbortError") setError(e?.message || "Unexpected error");
      } finally {
        if (alive && !bootstrapping) setLoadingPage(false);
      }
    }

    load();
    return () => {
      alive = false;
      controller.abort();
    };
  }, [bootstrapping]);

  // ==========================
  // 2) LOAD impltiming (local)
  // ==========================
  useEffect(() => {
    setImplTiming(Array.isArray(IMPLEMENTATION_TIMING) ? IMPLEMENTATION_TIMING : []);
  }, []);

  // ==========================
  // Names por tipo (desde DB)
  // ==========================
  const namesByType = useMemo(() => {
    const out = {
      Diet: [],
      Imports: [],
      Exports: [],
      ProtectedAreas: [],
      Afforestation: [],
      Population: [],
      LivestockProductivity: [],
      CropProductivity: [],
      Irrigation: [],
    };

    for (const s of customScenarios || []) {
      const type = String(s.type_scenario || "");
      const name = String(s.name || "").trim();
      if (!name) continue;
      if (out[type]) out[type].push(name);
    }

    for (const k of Object.keys(out)) {
      out[k] = Array.from(new Set(out[k])).sort((a, b) => a.localeCompare(b));
    }
    return out;
  }, [customScenarios]);

  const dietNamesCustom = namesByType.Diet;
  const importNamesCustom = namesByType.Imports;
  const exportNamesCustom = namesByType.Exports;
  const paNamesCustom = namesByType.ProtectedAreas;
  const affNamesCustom = namesByType.Afforestation;
  const popNamesCustom = namesByType.Population;
  const liveProdNamesCustom = namesByType.LivestockProductivity;
  const cropProdNamesCustom = namesByType.CropProductivity;
  const irrigationNamesCustom = namesByType.Irrigation;

  // ==========================
  // DIET TAB STATE
  // ==========================
  const [dietScenarioName, setDietScenarioName] = useState(
    () => localStorage.getItem("diet_selected") || "",
  );
  const [dietImplTiming, setDietImplTiming] = useState("");
  const [dietValues, setDietValues] = useState(() => {
    const init = {};
    DIET_FIELDS.forEach((k) => (init[k] = "0"));
    return init;
  });

  const toOneDecimal = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n)) return 0;
    return Number(n.toFixed(1));
  };

  const dietTotal = useMemo(() => {
    return toOneDecimal(
      DIET_FIELDS.reduce((sum, k) => sum + (Number(dietValues[k]) || 0), 0),
    );
  }, [dietValues]);

  // nombres base (del jsonData) + nombres custom (DB)
  const dietNames = useMemo(() => {
    const base = jsonData?.Diets ? Object.keys(jsonData.Diets) : [];
    return Array.from(new Set([...(base || []), ...(dietNamesCustom || [])])).sort((a, b) =>
      a.localeCompare(b),
    );
  }, [jsonData, dietNamesCustom]);

  // Cargar dieta desde jsonData si existe
  useEffect(() => {
    localStorage.setItem("diet_selected", dietScenarioName);
    if (!jsonData?.Diets) return;

    const dieta = jsonData.Diets[dietScenarioName];
    if (!dieta) return;

    setDietValues((prev) => {
      const next = { ...prev };
      DIET_FIELDS.forEach((k) => {
        next[k] = String(dieta?.[k] ?? 0);
      });
      return next;
    });
  }, [dietScenarioName, jsonData]);

  // ✅ Cargar dieta desde DB si existe (tiene prioridad si coincide)
  useEffect(() => {
    const name = normalizeString(dietScenarioName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "Diet" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const diet = cfg?.Diet || cfg;
    const timing = diet?.implementationTiming;
    if (typeof timing === "string" && timing) setDietImplTiming(timing);

    // esperamos que venga { [name]: {CEREALS..} } o directo {CEREALS..}
    const valuesObj = diet?.[name] && typeof diet?.[name] === "object" ? diet[name] : diet;

    setDietValues((prev) => {
      const next = { ...prev };
      DIET_FIELDS.forEach((k) => {
        next[k] = String(valuesObj?.[k] ?? 0);
      });
      return next;
    });
  }, [dietScenarioName, customScenarios]);

  useEffect(() => {
    if (!dietImplTiming && implOptions.length) setDietImplTiming(implOptions[0]);
  }, [implOptions, dietImplTiming]);

  // ==========================
  // IMPORTS TAB STATE
  // ==========================
  const [importName, setImportName] = useState("");
  const [importImplTiming, setImportImplTiming] = useState("");
  const [importItems, setImportItems] = useState([]); // [{id, product, share2050}]
  const impIdRef = useRef(0);

  useEffect(() => {
    if (!importImplTiming && implOptions.length) setImportImplTiming(implOptions[0]);
  }, [implOptions, importImplTiming]);

  const initialImportsSorted = useMemo(() => {
    const arr = jsonData?.initial_imports || [];
    return [...arr].sort((a, b) => String(a.Product).localeCompare(String(b.Product)));
  }, [jsonData]);

  const selectedImportProducts = useMemo(
    () => new Set(importItems.map((x) => x.product).filter(Boolean)),
    [importItems],
  );

  const availableImportProducts = useMemo(() => {
    return initialImportsSorted
      .map((x) => ({ value: x.Product, label: formatProductName(x.Product) }))
      .filter((opt) => opt.value && !selectedImportProducts.has(opt.value));
  }, [initialImportsSorted, selectedImportProducts]);

  const addImportItem = () => {
    setImportItems((prev) => [...prev, { id: ++impIdRef.current, product: "", share2050: "" }]);
  };

  const removeImportItem = (id) => {
    setImportItems((prev) => prev.filter((x) => x.id !== id));
  };

  const updateImportItem = (id, patch) => {
    setImportItems((prev) => prev.map((x) => (x.id === id ? { ...x, ...patch } : x)));
  };

  function getImportMatch(product) {
    const key = String(product ?? "").trim().toLowerCase();
    return (
      initialImportsSorted.find(
        (x) => String(x.Product ?? "").trim().toLowerCase() === key,
      ) || null
    );
  }

  // ✅ Autoload Imports desde DB
  useEffect(() => {
    const name = normalizeString(importName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "Imports" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setImportImplTiming(timing);

    const products = extractProductsFromConfig(cfg);
    setImportItems(
      (products || []).map((p, idx) => ({
        id: idx + 1,
        product: p?.Product || "",
        share2050:
          p?.ShareImport2050 !== undefined && p?.ShareImport2050 !== null
            ? String(Number(p.ShareImport2050) * 100)
            : "",
      })),
    );
    impIdRef.current = (products || []).length;
  }, [importName, customScenarios]);

  // ==========================
  // EXPORTS TAB STATE
  // ==========================
  const [exportName, setExportName] = useState("");
  const [exportImplTiming, setExportImplTiming] = useState("");
  const [exportItems, setExportItems] = useState([]); // [{id, product, netExport2050}]
  const expIdRef = useRef(0);

  useEffect(() => {
    if (!exportImplTiming && implOptions.length) setExportImplTiming(implOptions[0]);
  }, [implOptions, exportImplTiming]);

  const initialExportsSorted = useMemo(() => {
    const arr = jsonData?.initial_exports || [];
    return [...arr].sort((a, b) => String(a.Product).localeCompare(String(b.Product)));
  }, [jsonData]);

  const selectedExportProducts = useMemo(
    () => new Set(exportItems.map((x) => x.product).filter(Boolean)),
    [exportItems],
  );

  const availableExportProducts = useMemo(() => {
    return initialExportsSorted
      .map((x) => ({ value: x.Product, label: formatProductName(x.Product) }))
      .filter((opt) => opt.value && !selectedExportProducts.has(opt.value));
  }, [initialExportsSorted, selectedExportProducts]);

  const addExportItem = () => {
    setExportItems((prev) => [...prev, { id: ++expIdRef.current, product: "", netExport2050: "" }]);
  };

  const removeExportItem = (id) => {
    setExportItems((prev) => prev.filter((x) => x.id !== id));
  };

  const updateExportItem = (id, patch) => {
    setExportItems((prev) => prev.map((x) => (x.id === id ? { ...x, ...patch } : x)));
  };

  function getExportMatch(product) {
    const key = String(product ?? "").trim().toLowerCase();
    return (
      initialExportsSorted.find(
        (x) => String(x.Product ?? "").trim().toLowerCase() === key,
      ) || null
    );
  }

  // ✅ Autoload Exports desde DB
  useEffect(() => {
    const name = normalizeString(exportName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "Exports" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setExportImplTiming(timing);

    const products = extractProductsFromConfig(cfg);
    setExportItems(
      (products || []).map((p, idx) => ({
        id: idx + 1,
        product: p?.Product || "",
        netExport2050:
          p?.netExport2050 !== undefined && p?.netExport2050 !== null
            ? String(p.netExport2050)
            : "",
      })),
    );
    expIdRef.current = (products || []).length;
  }, [exportName, customScenarios]);

  // ==========================
  // PROTECTED AREAS TAB STATE
  // ==========================
  const [paName, setPaName] = useState("");
  const [paMinShare, setPaMinShare] = useState("");
  const [paTargetShare, setPaTargetShare] = useState("");
  const [paImplTiming, setPaImplTiming] = useState("");

  useEffect(() => {
    if (!paImplTiming && implOptions.length) setPaImplTiming(implOptions[0]);
  }, [implOptions, paImplTiming]);

  // ✅ Autoload ProtectedAreas desde DB
  useEffect(() => {
    const name = normalizeString(paName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "ProtectedAreas" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setPaImplTiming(timing);

    if (cfg?.minShare !== undefined && cfg?.minShare !== null) {
      setPaMinShare(String(Number(cfg.minShare) * 100));
    }
    if (cfg?.targetShare !== undefined && cfg?.targetShare !== null) {
      setPaTargetShare(String(Number(cfg.targetShare) * 100));
    }
  }, [paName, customScenarios]);

  // ==========================
  // AFFORESTATION TAB STATE
  // ==========================
  const [affName, setAffName] = useState("");
  const [affTarget, setAffTarget] = useState("");
  const [affImplTiming, setAffImplTiming] = useState("");

  // ==========================
  // POPULATION TAB STATE
  // ==========================
  const [popName, setPopName] = useState("");
  const [popTarget, setPopTarget] = useState("");
  const [popUrbanShare, setPopUrbanShare] = useState("20");
  const [popImplTiming, setPopImplTiming] = useState("");

  // ==========================
  // LIVESTOCK PRODUCTIVITY TAB STATE
  // ==========================
  const LIVESTOCK_DEFAULT_VALUES = {
    BOVD_beef: "1",
    BOVD_milk: "1",
    BOVO_beef: "1",
    PIGS_pork: "1",
    PTRB_chicken: "1",
    PTRH_eggs: "1",
    PTRX_chicken: "1",
    PTRX_eggs: "1",
    SGTD_milk: "1",
    SGTD_mutton_goat: "1",
    SGTO_mutton_goat: "1",
  };
  const [liveScenarioName, setLiveScenarioName] = useState("");
  const [liveImplTiming, setLiveImplTiming] = useState("");
  const [liveValues, setLiveValues] = useState(() => {
    return { ...LIVESTOCK_DEFAULT_VALUES };
  });

  // ==========================
  // CROP PRODUCTIVITY TAB STATE
  // ==========================
  const [cropScenarioName, setCropScenarioName] = useState("");
  const [cropImplTiming, setCropImplTiming] = useState("");
  const [cropValues, setCropValues] = useState(() => {
    const init = {};
    CROP_FIELDS.forEach(({ key, defaultYield }) => (init[key] = String(defaultYield)));
    return init;
  });

  // ==========================
  // IRRIGATION TAB STATE
  // ==========================
  const IRRIGATION_DEFAULT_VALUES = {
    BEVSPICES: "3",
    OLSOIL: "9",
    CEREALS: "2",
    PULSES: "2",
    FIBERINDUS: "1",
    ROOTS: "73",
    FRUVEG: "12",
    SUGAR: "11",
    NUTS: "5",
  };
  const [irrigationName, setIrrigationName] = useState("");
  const [irrigationImplTiming, setIrrigationImplTiming] = useState("");
  const [irrigationValues, setIrrigationValues] = useState(() => {
    return { ...IRRIGATION_DEFAULT_VALUES };
  });

  useEffect(() => {
    if (!affImplTiming && implOptions.length) setAffImplTiming(implOptions[0]);
  }, [implOptions, affImplTiming]);

  useEffect(() => {
    if (!popImplTiming && implOptions.length) setPopImplTiming(implOptions[0]);
  }, [implOptions, popImplTiming]);

  useEffect(() => {
    if (!liveImplTiming && implOptions.length) setLiveImplTiming(implOptions[0]);
  }, [implOptions, liveImplTiming]);

  useEffect(() => {
    if (!cropImplTiming && implOptions.length) setCropImplTiming(implOptions[0]);
  }, [implOptions, cropImplTiming]);

  useEffect(() => {
    if (!irrigationImplTiming && implOptions.length) setIrrigationImplTiming(implOptions[0]);
  }, [implOptions, irrigationImplTiming]);

  // ✅ Autoload Afforestation desde DB
  useEffect(() => {
    const name = normalizeString(affName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "Afforestation" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setAffImplTiming(timing);

    const target = cfg?.minShare ?? cfg?.target ?? cfg?.targetArea ?? null;
    if (target !== null && target !== undefined) setAffTarget(String(target));
  }, [affName, customScenarios]);

  // ✅ Autoload Population desde DB
  useEffect(() => {
    const name = normalizeString(popName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "Population" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setPopImplTiming(timing);

    const target = cfg?.minShare ?? cfg?.target ?? cfg?.targetArea ?? null;
    if (target !== null && target !== undefined) setPopTarget(String(target));

    const urbanTarget = cfg?.targetUrbanShare ?? cfg?.urbanShare ?? cfg?.targetUrbanShare2050 ?? null;
    if (urbanTarget !== null && urbanTarget !== undefined) setPopUrbanShare(String(urbanTarget));

  }, [popName, customScenarios]);

  // ✅ Autoload LivestockProductivity desde DB
  useEffect(() => {
    const name = normalizeString(liveScenarioName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "LivestockProductivity" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setLiveImplTiming(timing);

    const categories = Array.isArray(cfg?.categories) ? cfg.categories : null;
    if (categories) {
      setLiveValues((prev) => {
        const next = { ...prev };
        categories.forEach(({ ANIMAL_GLOBIOM, Product, ProductGrowth }) => {
          const field = LIVESTOCK_FIELDS.find(
            (f) => f.animal === ANIMAL_GLOBIOM && f.product === Product,
          );
          if (field) next[field.key] = String(Number(ProductGrowth) || 1);
        });
        return next;
      });
    }
  }, [liveScenarioName, customScenarios]);

  // ✅ Autoload CropProductivity desde DB
  useEffect(() => {
    const name = normalizeString(cropScenarioName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "CropProductivity" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setCropImplTiming(timing);

    const rows = Array.isArray(cfg?.rows) ? cfg.rows : null;
    if (rows) {
      setCropValues((prev) => {
        const next = { ...prev };
        rows.forEach(({ Crop, TargetYieldGap }) => {
          const field = CROP_FIELDS.find((f) => f.crop === Crop);
          if (field) {
            const numericValue = parseFloat(String(TargetYieldGap));
            next[field.key] = String(Math.min(100, Number.isFinite(numericValue) ? numericValue : field.defaultYield));
          }
        });
        return next;
      });
    }
  }, [cropScenarioName, customScenarios]);

  // ✅ Autoload Irrigation desde DB
  useEffect(() => {
    const name = normalizeString(irrigationName);
    if (!name) return;

    const row = (customScenarios || []).find(
      (s) => String(s.type_scenario) === "Irrigation" && String(s.name) === name,
    );
    if (!row?.config) return;

    const cfg = ensureObjectConfig(row.config);
    if (!cfg) return;

    const timing = cfg?.implementationTiming;
    if (typeof timing === "string" && timing) setIrrigationImplTiming(timing);

    const valuesObj = cfg?.[name] && typeof cfg[name] === "object" ? cfg[name] : cfg;
    setIrrigationValues((prev) => {
      const next = { ...prev };
      IRRIGATION_FIELDS.forEach((k) => {
        next[k] = String(valuesObj?.[k] ?? 0);
      });
      return next;
    });
  }, [irrigationName, customScenarios]);

  // ==========================
  // overlay pointer-events
  // ==========================
  // =========================================================
  // ✅ Helpers: exists + tasktodo flow
  // =========================================================
  const checkScenarioExists = useCallback(
    async ({ name, type_scenario, country }) => {
      const params = new URLSearchParams({ name, type_scenario, country });
      const res = await authFetch(`/api/scenarios/exists?${params.toString()}`, {
        method: "GET",
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || `Error ${res.status}`);
      return !!data?.exists;
    },
    [authFetch],
  );

  const confirmReplaceIfExists = async ({ exists, name }) => {
    if (!exists) return { overwrite: false };

    const choice = await Swal.fire({
      icon: "warning",
      title: "Scenario already exists",
      text: `A scenario named "${name}" already exists. Do you want to replace it or change the name?`,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Replace",
      denyButtonText: "Change name",
      cancelButtonText: "Cancel",
      ...SWEETALERT_THEME,
    });

    if (choice.isDenied) return { cancelled: true };
    if (!choice.isConfirmed) return { cancelled: true };
    return { overwrite: true };
  };

  const confirmSend = async () => {
    const c = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit your data?\nClick Confirm to continue or Cancel to review.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      ...SWEETALERT_THEME,
    });
    return c.isConfirmed;
  };

  const getTaskIdByScenario = (scenarioType) => {
    const map = {
      Diet: 1,
      Imports: 2,
      Exports: 3,
      ProtectedAreas: 5,
      Afforestation: 6,
      Population: 7,
      LivestockProductivity: 8,
      CropProductivity: 9,
      Irrigation: 10,
    };

    return map[scenarioType] ?? 0;
  };

  const saveScenarioViaTasktodo = useCallback(
    async ({ name, colname, colvalue, task_id }) => {
      const res = await authFetch("/api/sendtask/tasktodo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          task_id,
          name,
          status: "todo",
          onpc: 1,
          colname,
          colvalue,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || `Error creating task (${res.status})`);
      const id = data?.id;
      if (!id) throw new Error("Backend did not return task id.");
      return { id, ok: true };
    },
    [authFetch],
  );

  // =========================================================
  // ✅ SUBMITS (Diet / Imports / Exports / PA / Afforestation)
  // =========================================================
  const submitDiet = async () => {
    try {
      setError("");

      const name = dietScenarioName.trim();
      if (!name) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Scenario Name is empty", ...SWEETALERT_THEME, });
        return;
      }
      if (!dietImplTiming) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Implementation Timing is empty",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const dietData2 = {};
      DIET_FIELDS.forEach((k) => {
        dietData2[k] = toOneDecimal(clampNum(dietValues[k], 0, 2000) ?? 0);
      });

      const colvalue = {
        Diet: {
          Name: name,
          implementationTiming: dietImplTiming,
          [name]: dietData2,
        },
      };

      const exists = await checkScenarioExists({ name, type_scenario: "Diet", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "Diet",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("Diet"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "Diet", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      if (err?.code === "SCENARIO_EXISTS") {
        await Swal.fire({
          icon: "warning",
          title: "Scenario already exists",
          text: "Ese scenario ya existe. Cambia el nombre o elige reemplazar.",
          ...SWEETALERT_THEME,
        });
        return;
      }
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitIrrigation = async () => {
    try {
      setError("");

      const name = irrigationName.trim();
      if (!name) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Scenario Name is empty", ...SWEETALERT_THEME, });
        return;
      }
      if (!irrigationImplTiming) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Implementation Timing is empty",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const irrigationData = {};
      IRRIGATION_FIELDS.forEach((k) => {
        irrigationData[k] = toOneDecimal(clampNum(irrigationValues[k], 0, 100) ?? 0);
      });

      const colvalue = {
        irrigation: {
          implementation: irrigationImplTiming,
          [name]: irrigationData,
        },
      };

      const exists = await checkScenarioExists({ name, type_scenario: "Irrigation", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "irrigation",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("Irrigation"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "irrigation", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      if (err?.code === "SCENARIO_EXISTS") {
        await Swal.fire({
          icon: "warning",
          title: "Scenario already exists",
          text: "Ese scenario ya existe. Cambia el nombre o elige reemplazar.",
          ...SWEETALERT_THEME,
        });
        return;
      }
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitImports = async () => {
    try {
      setError("");

      const name = importName.trim();
      if (!name) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Scenario Name is empty", ...SWEETALERT_THEME, });
        return;
      }
      if (!importImplTiming) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Implementation Timing is empty",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const productos = [];
      for (const item of importItems) {
        if (!item.product || item.share2050 === "" || item.share2050 === null) continue;
        const match = getImportMatch(item.product);
        if (!match) continue;

        productos.push({
          Product: item.product,
          NetImport: parseFloat(match.NetImport),
          ShareImport2020: parseFloat(match.ShareImport),
          ShareImport2050: parseFloat(item.share2050) / 100,
        });
      }

      if (!productos.length) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Please add at least one product with valid data.",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const colvalue = {
        scenarioName: name,
        implementationTiming: importImplTiming,
        products: productos,
      };

      const exists = await checkScenarioExists({ name, type_scenario: "Imports", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "PorcentajeImportado",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("Imports"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "PorcentajeImportado", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      if (err?.code === "SCENARIO_EXISTS") {
        await Swal.fire({
          icon: "warning",
          title: "Scenario already exists",
          text: "Ese scenario ya existe. Cambia el nombre o elige reemplazar.",
          ...SWEETALERT_THEME,
        });
        return;
      }
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitExports = async () => {
    try {
      setError("");

      const name = exportName.trim();
      if (!name) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Scenario Name is empty",...SWEETALERT_THEME, });
        return;
      }
      if (!exportImplTiming) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Implementation Timing is empty",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const productos = [];
      for (const item of exportItems) {
        if (!item.product || item.netExport2050 === "" || item.netExport2050 === null) continue;
        const match = getExportMatch(item.product);
        if (!match) continue;

        productos.push({
          Product: item.product,
          netExport: parseFloat(match.NetExport),
          netExport2050: parseFloat(item.netExport2050),
        });
      }

      if (!productos.length) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Please add at least one product with valid data.",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const colvalue = {
        scenarioName: name,
        implementationTiming: exportImplTiming,
        products: productos,
      };

      const exists = await checkScenarioExists({ name, type_scenario: "Exports", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "EvolucionExportaciones",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("Exports"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "EvolucionExportaciones", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      if (err?.code === "SCENARIO_EXISTS") {
        await Swal.fire({
          icon: "warning",
          title: "Scenario already exists",
          text: "Ese scenario ya existe. Cambia el nombre o elige reemplazar.",
          ...SWEETALERT_THEME,
        });
        return;
      }
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitPA = async () => {
    try {
      setError("");

      const name = paName.trim();
      const minShare = clampNum(paMinShare, 0, 100);
      const targetShare = clampNum(paTargetShare, 0, 100);

      if (!name || minShare === null || targetShare === null || !paImplTiming) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Please, complete all fields",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const colvalue = {
        scenarioName: name,
        minShare: minShare / 100,
        targetShare: targetShare / 100,
        implementationTiming: paImplTiming,
      };

      const exists = await checkScenarioExists({
        name,
        type_scenario: "ProtectedAreas",
        country,
      });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "ExpansionAreasProtegidas",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("ProtectedAreas"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "ExpansionAreasProtegidas", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      if (err?.code === "SCENARIO_EXISTS") {
        await Swal.fire({
          icon: "warning",
          title: "Scenario already exists",
          text: "Ese scenario ya existe. Cambia el nombre o elige reemplazar.",
          ...SWEETALERT_THEME,
        });
        return;
      }
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitLivestock = async () => {
    try {
      setError("");

      const name = liveScenarioName.trim();
      if (!name) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Scenario Name is empty", ...SWEETALERT_THEME });
        return;
      }
      if (!liveImplTiming) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Implementation Timing is empty", ...SWEETALERT_THEME });
        return;
      }

      const categories = LIVESTOCK_FIELDS.map(({ key, animal, product }) => ({
        ANIMAL_GLOBIOM: animal,
        Product: product,
        ProductGrowth: clampNum(liveValues[key], 0, 10) ?? 1,
      }));

      const colvalue = {
        scenarioName: name,
        implementationTiming: liveImplTiming,
        categories,
      };

      const exists = await checkScenarioExists({ name, type_scenario: "LivestockProductivity", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "LivestockProductivity",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("LivestockProductivity"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "LivestockProductivity", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitCrop = async () => {
    try {
      setError("");

      const name = cropScenarioName.trim();
      if (!name) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Scenario Name is empty", ...SWEETALERT_THEME });
        return;
      }
      if (!cropImplTiming) {
        await Swal.fire({ icon: "warning", title: "Warning!", text: "Implementation Timing is empty", ...SWEETALERT_THEME });
        return;
      }

      const rows = CROP_FIELDS.map(({ key, crop }) => ({
        Crop: crop,
        TargetYieldGap: `${clampNum(cropValues[key], 0, 100) ?? 0}%`,
      }));

      const colvalue = {
        scenarioName: name,
        implementationTiming: cropImplTiming,
        rows,
      };

      const exists = await checkScenarioExists({ name, type_scenario: "CropProductivity", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "CropProductivity",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("CropProductivity"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "CropProductivity", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitPopulation = async () => {
    try {
      setError("");

      const name = popName.trim();
      const popt2050 = clampNum(popTarget, 0, 100000000);
      const popUrbanTarget = clampNum(popUrbanShare, 0, 100);

      if (!name || popt2050 === null || !popImplTiming) {
        return setError("Please fill in all required fields.");
      }

      // Build poblacion array using interpolation formula:
      // value_year = VAL_2020 + (VAL_2050 - VAL_2020) * COEF_year
      const coefs = POPULATION_IMPL_COEFS[popImplTiming] ?? POPULATION_IMPL_COEFS.Linear;
      const poblacion = POPULATION_YEARS.map((year, i) => ({
        YEAR: year,
        POPT: parseFloat((POPULATION_VAL_2020 + (popt2050 - POPULATION_VAL_2020) * coefs[i]).toFixed(6)),
        Urbanshare: parseFloat((URBAN_VAL_2020 + (popUrbanTarget - URBAN_VAL_2020) * coefs[i]).toFixed(6)),
      }));

      const colvalue = {
        scenarioName: name,
        implementationTiming: popImplTiming,
        minShare: popt2050,
        poblacion,
      };

      const exists = await checkScenarioExists({ name, type_scenario: "Population", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "Population",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("Population"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "Population", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitAfforestation = async () => {
    try {
      setError("");

      const name = affName.trim();
      const target = clampNum(affTarget, 0, 100000000);

      if (!name || target === null || !affImplTiming) {
        await Swal.fire({
          icon: "warning",
          title: "Warning!",
          text: "Please, complete all fields",
          ...SWEETALERT_THEME,
        });
        return;
      }

      const colvalue = {
        scenarioName: name,
        minShare: target,
        implementationTiming: affImplTiming,
      };

      const exists = await checkScenarioExists({ name, type_scenario: "Afforestation", country });
      const r = await confirmReplaceIfExists({ exists, name });
      if (r.cancelled) return;

      const ok = await confirmSend();
      if (!ok) return;

      setIsSubmitting(true);
      const resp = await saveScenarioViaTasktodo({
        name,
        colname: "Forestacion",
        colvalue,
        overwrite: r.overwrite,
        task_id: getTaskIdByScenario("Afforestation"),
      });
      startPendingTask({ id: resp.id, name, country, colname: "Forestacion", overwrite: r.overwrite });
      await Swal.fire({
        icon: "info",
        title: "Task sent",
        text: "Your scenario is being processed in background. You can navigate or refresh safely.",
        ...SWEETALERT_THEME,
      });
    } catch (err) {
      if (err?.code === "SCENARIO_EXISTS") {
        await Swal.fire({
          icon: "warning",
          title: "Scenario already exists",
          text: "Ese scenario ya existe. Cambia el nombre o elige reemplazar.",
          ...SWEETALERT_THEME,
        });
        return;
      }
      console.error(err);
      setError(err?.message || "Error enviando datos");
    } finally {
      setIsSubmitting(false);
    }
  };

  // =========================================================
  // Escucha eventos globales de tarea completada / fallida
  // =========================================================
  useEffect(() => {
    const onCompleted = async (event) => {
      const taskMeta = event?.detail?.pendingTask || {};
      if (taskMeta?.colname === "Pathway") return;
      try { await refreshDefined(); } catch { /* silent */ }
      await Swal.fire({
        icon: "success",
        title: "Saved",
        text: "Scenario processed and saved successfully.",
        ...SWEETALERT_THEME,
      });
    };
    const onFailed = async (event) => {
      const detail = event?.detail || {};
      const taskMeta = detail?.pendingTask || {};
      if (taskMeta?.colname === "Pathway") return;
      const errMessage = detail?.error || "Error processing scenario task";
      setError(errMessage);
      await Swal.fire({
        icon: "error",
        title: "Task failed",
        text: errMessage,
        ...SWEETALERT_THEME,
      });
    };
    window.addEventListener("scenathon-task-completed", onCompleted);
    window.addEventListener("scenathon-task-failed", onFailed);
    return () => {
      window.removeEventListener("scenathon-task-completed", onCompleted);
      window.removeEventListener("scenathon-task-failed", onFailed);
    };
  }, [refreshDefined]);

  const sendDisabled = isSubmitting || !!pendingTask?.id;
  const hasScenarioPending = !!pendingTask?.id && pendingTask?.colname !== "Pathway";
  const scenarioBusyLabel = hasScenarioPending
    ? "Adding Scenario..."
    : "Launching Scenario...";

  // ==========================
  // render helpers
  // ==========================
  const TabButton = ({ n, children }) => (
    <button
      type="button"
      onClick={() => setTab(n)}
      className={[
        "px-4 py-2.5 text-sm font-semibold rounded-xl border transition-all duration-200",
        tab === n
          ? "bg-[#1E5B4F]/90 border-[#C49A1F]/70 text-white shadow-[0_10px_24px_rgba(30,91,79,0.3)]"
          : "bg-white/50 border-white/60 text-slate-700 hover:bg-white/70 hover:border-[#C49A1F]/45 hover:-translate-y-0.5",
      ].join(" ")}
    >
      {children}
    </button>
  );

  return (
    <div className={`${noTopMargin ? "" : "mt-10 "}w-full bg-slate-50 rounded-xl shadow-sm`}>
      {Sidebar ? <Sidebar /> : null}

      <main className="mx-auto w-full px-4 py-8 sm:px-6 lg:px-8">
        {hasScenarioPending && (
          <div className="mb-4 rounded-2xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-900">
            {`Scenario task #${pendingTask.id} is processing (${pendingTaskState || "pending"}). You can keep working while it finishes.`}
            <div className="mt-3 flex w-full max-w-sm items-center gap-1" aria-hidden="true">
              <span className="h-1 flex-1 animate-pulse rounded-full bg-blue-300" />
              <span
                className="h-1 flex-1 animate-pulse rounded-full bg-blue-400"
                style={{ animationDelay: "0.15s" }}
              />
              <span
                className="h-1 flex-1 animate-pulse rounded-full bg-blue-500"
                style={{ animationDelay: "0.3s" }}
              />
            </div>
          </div>
        )}

        {error && (
          <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 p-4 text-sm text-red-800">
            {error}
          </div>
        )}

        {/* Tabs header */}
        {!hideTabsHeader && !forcedTab && (
          <div className="flex flex-wrap gap-2 rounded-2xl border border-white/45 bg-white/35 p-2.5 backdrop-blur-md shadow-[0_12px_30px_rgba(15,23,42,0.08)]">
            <TabButton n={6}>
              {t("scenario.tabs.population", { defaultValue: "Population" })}
            </TabButton>
            <TabButton n={1}>{t("scenario.tabs.diet", { defaultValue: "Diet" })}</TabButton>
            <TabButton n={2}>{t("scenario.tabs.imports", { defaultValue: "Imports" })}</TabButton>
            <TabButton n={3}>{t("scenario.tabs.exports", { defaultValue: "Exports" })}</TabButton>
            <TabButton n={7}>
              {t("scenario.tabs.livestock", { defaultValue: "Livestock Productivity" })}
            </TabButton>
            <TabButton n={8}>
              {t("scenario.tabs.crop", { defaultValue: "Crop Productivity" })}
            </TabButton>
            <TabButton n={10}>{t("scenario.tabs.irrigation", { defaultValue: "Irrigation" })}</TabButton>
            <TabButton n={4}>
              {t("scenario.tabs.protected", { defaultValue: "Protected areas expansion" })}
            </TabButton>
            <TabButton n={5}>
              {t("scenario.tabs.afforestation", { defaultValue: "Afforestation" })}
            </TabButton>
          </div>
        )}

        {/* Content */}
        <div className={noTopMargin ? "" : "mt-4"}>
          {loadingPage ? (
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <SkeletonCard />
              <SkeletonCard />
              <SkeletonCard />
              <SkeletonCard />
            </div>
          ) : (
            <>
              {/* TAB 1: DIET */}
              {tab === 1 && (
                <section className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-bold text-slate-900">
                      {t("scenario.diet.title", { defaultValue: "Diet Scenario" })}
                    </h2>
                    <div
                      className={
                        `inline-flex items-center gap-2 rounded-xl px-5 py-2 text-lg font-bold shadow-sm ` +
                        (dietTotal <= 1500 || dietTotal >=3000
                          ? 'bg-red-50 border border-red-200 text-red-800'
                          : dietTotal > 1500 && dietTotal <= 2000 || dietTotal > 2500 && dietTotal < 3000
                          ? 'bg-yellow-50 border border-yellow-200 text-yellow-800'
                          : 'bg-green-50 border border-green-200 text-green-800')
                      }
                    >
                      <span>{t("scenario.diet.total", { defaultValue: "Total (Kcal/cap/day):" })}</span>
                      <span className={dietTotal <= 1500 || dietTotal >= 3000 ? "text-2xl font-extrabold text-red-700" : dietTotal > 1500 && dietTotal <= 2000 || dietTotal > 2500 && dietTotal < 3000 ? "text-2xl font-extrabold text-yellow-700" : "text-2xl font-extrabold text-green-700"}>{dietTotal}</span>
                    </div>
                  </div>
                  
                    <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                      To create a Diet Scenario, type a name for it, set the implementation timing (how it reaches that value starting from 2025), and select the amount of kcal per capita per day for each of the food groups. You can start from the current diet by selecting “FAO 2020” first, and then modifying the name and values to reflect your expected diet by 2050. Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                    </p>

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                    <Field label={t("scenario.labels.name", { defaultValue: "NAME" })}>
                      <input
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={dietScenarioName}
                        onChange={(e) => setDietScenarioName(e.target.value)}
                        placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                        list="datalist-diets"
                      />
                      <datalist id="datalist-diets">
                        {dietNames.map((d) => (
                          <option key={d} value={d} />
                        ))}
                      </datalist>
                    </Field>
                    <Field label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}>
                      <Select
                        value={dietImplTiming}
                        onChange={setDietImplTiming}
                        options={implOptions}
                        placeholder="Select implementation timing"
                      />
                    </Field>
                  </div>

                  <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                    {DIET_FIELDS.map((field) => (
                      <div key={field} className="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
                        <div className="flex items-center justify-between">
                          <div className="text-sm font-semibold text-slate-900">{field}</div>
                          <input
                            type="number"
                            min={0}
                            max={2000}
                            step={1}
                            className="w-24 rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm outline-none focus:border-slate-400"
                            value={dietValues[field] ?? ""}
                            onChange={(e) =>
                              setDietValues((prev) => ({
                                ...prev,
                                [field]: e.target.value,
                              }))
                            }
                            onBlur={(e) =>
                              setDietValues((prev) => {
                                const rawValue = e.target.value;
                                const numericValue = Number(rawValue);
                                return {
                                  ...prev,
                                  [field]: rawValue === "" || !Number.isFinite(numericValue)
                                    ? "0"
                                    : String(Math.min(2000, Math.max(0, numericValue))),
                                };
                              })
                            }
                          />
                        </div>

                        <input
                          type="range"
                          min={0}
                          max={2000}
                          step={1}
                          className="mt-3 w-full"
                          value={clampNum(dietValues[field], 0, 2000) ?? 0}
                          onChange={(e) =>
                            setDietValues((prev) => ({
                              ...prev,
                              [field]: String(e.target.value),
                            }))
                          }
                        />
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 text-center">
                    <PrimaryButton onClick={submitDiet} disabled={sendDisabled}>
                      {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                    </PrimaryButton>
                  </div>
                </section>
              )}

              {/* TAB 2: IMPORTS */}
              {tab === 2 && (
                <section className="space-y-4">
                  <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                    <h2 className="text-lg font-bold text-slate-900">
                      {t("scenario.imports.title", { defaultValue: "Imports Scenario" })}
                    </h2>
                    <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                      To create an Import Scenario, type a name for it, set the implementation timing (how it reaches that value starting from 2025), click to add products, and set the share of imports (%) of that products by 2050. You can see the most relevant imports and their shares in 2020. Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                    </p>

                    <h3 className="mt-4 text-sm font-semibold text-slate-700">
                      {t("scenario.imports.mainProducts2020", {
                        defaultValue: "Main imported products in 2020",
                      })}
                    </h3>

                    <SimpleTable
                      headers={["", ...(jsonData?.topimports || []).map((_, i) => String(i + 1))]}
                      rows={[
                        [
                          t("scenario.labels.product", { defaultValue: "Product" }),
                          ...(jsonData?.topimports || []).map((x) => formatProductName(x.Product)),
                        ],
                        [
                          t("scenario.imports.netImports2020", {
                            defaultValue: "Net Imports 2020 (1000 tons)",
                          }),
                          ...(jsonData?.topimports || []).map((x) => String(x.NetImport)),
                        ],
                        [
                          t("scenario.imports.shareImports2020", {
                            defaultValue: "Share of Imports 2020 (%)",
                          }),
                          ...(jsonData?.topimports || []).map((x) =>
                            ((x.ShareImport || 0) * 100).toFixed(1),
                          ),
                        ],
                      ]}
                    />
                  </div>

                  <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                      <Field label={t("scenario.labels.scenarioName", { defaultValue: "Scenario Name" })}>
                        <input
                          className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                          value={importName}
                          onChange={(e) => setImportName(e.target.value)}
                          placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                          list="datalist-imports"
                        />
                        <datalist id="datalist-imports">
                          {importNamesCustom.map((n) => (
                            <option key={n} value={n} />
                          ))}
                        </datalist>
                      </Field>

                      <Field
                        label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}
                      >
                        <Select
                          value={importImplTiming}
                          onChange={setImportImplTiming}
                          options={implOptions}
                          placeholder="Select implementation timing"
                        />
                      </Field>
                    </div>

                    <div className="mt-4 flex items-center gap-2">
                      <button
                        type="button"
                        onClick={addImportItem}
                        className="rounded-xl bg-[#1E5B4F]/90 hover:bg-[#1E5B4F] px-6 py-0.8 text-sm font-semibold text-white"
                      >
                        +
                      </button>

                      <h3 className="text-base font-bold text-slate-900">
                        {t("scenario.addProducts", { defaultValue: "Products" })}
                      </h3>
                    </div>

                    <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                      {importItems.map((item) => {
                        const match = getImportMatch(item.product);
                        const share2020Pct = match ? (match.ShareImport * 100).toFixed(1) : "";
                        const netImport2020 = match ? String(match.NetImport) : "";
                        const share2050Pct = item.share2050;

                        const expected2050 =
                          match && share2050Pct !== "" && match.ShareImport
                            ? (
                              (match.NetImport * (parseFloat(share2050Pct) / 100)) /
                              match.ShareImport
                            ).toFixed(0)
                            : "";

                        const allowed = [
                          ...(item.product
                            ? [{ value: item.product, label: formatProductName(item.product) }]
                            : []),
                          ...availableImportProducts,
                        ].filter(Boolean);

                        return (
                          <div key={item.id} className="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
                            <div className="grid grid-cols-1 gap-3">
                              <Field label="Product:">
                                <Select
                                  value={item.product || ""}
                                  onChange={(val) => updateImportItem(item.id, { product: val })}
                                  options={allowed}
                                  placeholder="Select Product"
                                />
                              </Field>

                              <Field label="Net Imports 2020:">
                                <input
                                  className="w-full rounded-xl border border-slate-200 bg-slate-100 px-3 py-2 text-sm outline-none"
                                  value={netImport2020}
                                  readOnly
                                />
                              </Field>

                              <Field label="Share of Imports 2020 (%):">
                                <input
                                  className="w-full rounded-xl border border-slate-200 bg-slate-100 px-3 py-2 text-sm outline-none"
                                  value={share2020Pct}
                                  readOnly
                                />
                              </Field>

                              <Field label="Share of Imports 2050 (%):">
                                <input
                                  type="number"
                                  min={0}
                                  max={100}
                                  className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-slate-400"
                                  value={share2050Pct}
                                  onChange={(e) =>
                                    updateImportItem(item.id, {
                                      share2050: clampNum(e.target.value, 0, 100) ?? "",
                                    })
                                  }
                                  placeholder="Value"
                                />
                              </Field>

                              <Field label="Expected Imports 2050:">
                                <input
                                  className="w-full rounded-xl border border-slate-200 bg-slate-100 px-3 py-2 text-sm outline-none"
                                  value={expected2050}
                                  readOnly
                                />
                              </Field>

                              <button
                                type="button"
                                onClick={() => removeImportItem(item.id)}
                                className="mt-1 rounded-xl bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-700"
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <div className="mt-6 text-center">
                      <PrimaryButton onClick={submitImports} disabled={sendDisabled}>
                        {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                      </PrimaryButton>
                    </div>
                  </div>
                </section>
              )}

              {/* TAB 3: EXPORTS */}
              {tab === 3 && (
                <section className="space-y-4">
                  <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                    <h2 className="text-lg font-bold text-slate-900">
                      {t("scenario.exports.title", { defaultValue: "Exports Scenario" })}
                    </h2>
                    <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                      To create an Export Scenario, type a name for it, set the implementation timing (how it reaches that value starting from 2025), click to add products, and set the expected exports (thousand tons) of that products by 2050. You can see the most relevant exports and their net exports in 2020. Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                    </p>

                    <h3 className="mt-4 text-sm font-semibold text-slate-700">
                      {t("scenario.exports.mainProducts2020", {
                        defaultValue: "Main exported products in 2020",
                      })}
                    </h3>

                    <SimpleTable
                      headers={[
                        "",
                        ...(jsonData?.topexports || []).slice(0, 5).map((_, i) => String(i + 1)),
                      ]}
                      rows={[
                        [
                          t("scenario.labels.product", { defaultValue: "Product" }),
                          ...(jsonData?.topexports || []).slice(0, 5).map((x) => formatProductName(x.Product)),
                        ],
                        [
                          t("scenario.exports.netExports2020", {
                            defaultValue: "Net Exports 2020 (1000 tons)",
                          }),
                          ...(jsonData?.topexports || []).slice(0, 5).map((x) =>
                            String((x.NetExport ?? 0).toFixed?.(0) ?? x.NetExport),
                          ),
                        ],
                      ]}
                    />
                  </div>

                  <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                      <Field label={t("scenario.labels.scenarioName", { defaultValue: "Scenario Name" })}>
                        <input
                          className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                          value={exportName}
                          onChange={(e) => setExportName(e.target.value)}
                          placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                          list="datalist-exports"
                        />
                        <datalist id="datalist-exports">
                          {exportNamesCustom.map((n) => (
                            <option key={n} value={n} />
                          ))}
                        </datalist>
                      </Field>

                      <Field
                        label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}
                      >
                        <Select
                          value={exportImplTiming}
                          onChange={setExportImplTiming}
                          options={implOptions}
                          placeholder="Select implementation timing"
                        />
                      </Field>
                    </div>

                    <div className="mt-4 flex items-center gap-2">
                      <button
                        type="button"
                        onClick={addExportItem}
                        className="rounded-xl bg-[#1E5B4F]/90 hover:bg-[#1E5B4F] px-6 py-0.8 text-sm font-semibold text-white"
                      >
                        +
                      </button>

                      <h3 className="text-base font-bold text-slate-900">
                        {t("scenario.addProducts", { defaultValue: "Products" })}
                      </h3>
                    </div>

                    <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                      {exportItems.map((item) => {
                        const match = getExportMatch(item.product);
                        const netExport2020 = match
                          ? String((match.NetExport ?? 0).toFixed?.(1) ?? match.NetExport)
                          : "";

                        const allowed = [
                          ...(item.product
                            ? [{ value: item.product, label: formatProductName(item.product) }]
                            : []),
                          ...availableExportProducts,
                        ].filter(Boolean);

                        return (
                          <div key={item.id} className="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
                            <div className="grid grid-cols-1 gap-3">
                              <Field label="Product:">
                                <Select
                                  value={item.product || ""}
                                  onChange={(val) => updateExportItem(item.id, { product: val })}
                                  options={allowed}
                                  placeholder="Select Product"
                                />
                              </Field>

                              <Field label="Net Exports 2020:">
                                <input
                                  className="w-full rounded-xl border border-slate-200 bg-slate-100 px-3 py-2 text-sm outline-none"
                                  value={netExport2020}
                                  readOnly
                                />
                              </Field>

                              <Field label="Net Exports 2050:">
                                <input
                                  type="number"
                                  min={0}
                                  className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                                  value={item.netExport2050}
                                  onChange={(e) =>
                                    updateExportItem(item.id, {
                                      netExport2050: clampNum(e.target.value, 0, 500000) ?? "",
                                    })
                                  }
                                  placeholder="Value"
                                />
                              </Field>

                              <button
                                type="button"
                                onClick={() => removeExportItem(item.id)}
                                className="mt-1 rounded-xl bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-700"
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <div className="mt-6 text-center">
                      <PrimaryButton onClick={submitExports} disabled={sendDisabled}>
                        {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                      </PrimaryButton>
                    </div>
                  </div>
                </section>
              )}

              {/* TAB 4: PROTECTED AREAS */}
              {tab === 4 && (
                <section className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                  <h2 className="text-lg font-bold text-slate-900">
                    {t("scenario.protected.title", {
                      defaultValue: "Protected Areas expansion Scenario",
                    })}
                  </h2>
                  <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                    To create a Protected Areas expansion Scenario, type a name for it, set minimum share of PA in each ecoregion (tip: around 5-10% to avoid inconsistent values), set the target share of PA by 2050 (% of the country area under protection) and choose the implementation timing (how it reaches that value starting from 2025). Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                  </p>

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-4">
                    <Field label={t("scenario.labels.scenarioName", { defaultValue: "Scenario Name" })}>
                      <input
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={paName}
                        onChange={(e) => setPaName(e.target.value)}
                        placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                        list="datalist-pa"
                      />
                      <datalist id="datalist-pa">
                        {paNamesCustom.map((n) => (
                          <option key={n} value={n} />
                        ))}
                      </datalist>
                    </Field>

                    <Field
                      label={t("scenario.protected.minShareEcoregion", {
                        defaultValue: "Minimum share in every ecoregion (%)",
                      })}
                    >
                      <input
                        type="number"
                        min={0}
                        max={100}
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={paMinShare}
                        onChange={(e) => setPaMinShare(clampNum(e.target.value, 0, 100) ?? "")}
                        placeholder={t("scenario.placeholders.enterValue", { defaultValue: "Enter Value" })}
                      />
                    </Field>

                    <Field
                      label={t("scenario.protected.targetSharePA", {
                        defaultValue: "Target share of PA by 2050 (%)",
                      })}
                    >
                      <input
                        type="number"
                        min={0}
                        max={100}
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={paTargetShare}
                        onChange={(e) => setPaTargetShare(clampNum(e.target.value, 0, 100) ?? "")}
                        placeholder={t("scenario.placeholders.enterValue", { defaultValue: "Enter Value" })}
                      />
                    </Field>

                    <Field
                      label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}
                    >
                      <Select
                        value={paImplTiming}
                        onChange={setPaImplTiming}
                        options={implOptions}
                        placeholder="Select implementation timing"
                      />
                    </Field>
                  </div>

                  <div className="mt-6 text-center">
                    <PrimaryButton onClick={submitPA} disabled={sendDisabled}>
                      {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                    </PrimaryButton>
                  </div>
                </section>
              )}

              {/* TAB 6: POPULATION */}
              {tab === 6 && (
                <section className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                  <h2 className="text-lg font-bold text-slate-900">
                    {t("scenario.population.title", { defaultValue: "Population Scenario" })}
                  </h2>
                  <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                    To create a Population Scenario, type a name for it, indicate how many inhabitants (in millions) you expect by 2050, what is the expected urban share, and set the implementation timing (how it reaches that value starting from 2025). Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                  </p>

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-4">
                    <Field label={t("scenario.labels.scenarioName", { defaultValue: "Scenario Name" })}>
                      <input
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={popName}
                        onChange={(e) => setPopName(e.target.value)}
                        placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                        list="datalist-pop"
                      />
                      <datalist id="datalist-pop">
                        {popNamesCustom.map((n) => (
                          <option key={n} value={n} />
                        ))}
                      </datalist>
                    </Field>

                    <Field
                      label={t("scenario.population.targetPop2050", {
                        defaultValue: "Target inhabitants by 2050 (millions)",
                      })}
                    >
                      <input
                        type="number"
                        min={0}
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={popTarget}
                        onChange={(e) => setPopTarget(clampNum(e.target.value, 0, 100000000) ?? "")}
                        placeholder={t("scenario.placeholders.enterValue", { defaultValue: "Enter Value" })}
                      />
                    </Field>

                    <Field
                      label={t("scenario.population.targetUrbanShare", {
                        defaultValue: "Target urban share by 2050 (%)",
                      })}
                    >
                      <input
                        type="number"
                        min={15}
                        max={60}
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={popUrbanShare}
                        onChange={(e) => setPopUrbanShare(clampNum(e.target.value, 15, 60) ?? "")}
                        placeholder={t("scenario.placeholders.enterValue", { defaultValue: "Enter Value" })}
                      />
                    </Field>

                    <Field
                      label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}
                    >
                      <Select
                        value={popImplTiming}
                        onChange={setPopImplTiming}
                        options={implOptions}
                        placeholder="Select implementation timing"
                      />
                    </Field>
                  </div>

                  <div className="mt-6 text-center">
                    <PrimaryButton onClick={submitPopulation} disabled={sendDisabled}>
                      {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                    </PrimaryButton>
                  </div>
                </section>
              )}

              {/* TAB 7: LIVESTOCK PRODUCTIVITY */}
              {tab === 7 && (
                <section className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                  <h2 className="text-lg font-bold text-slate-900">
                    {t("scenario.livestock.title", { defaultValue: "Livestock Productivity Scenario" })}
                  </h2>
                  <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                    To create a Livestock Productivity Scenario, type a name for it, set the implementation timing (how it reaches that value starting from 2025), and choose the productivity change by 2050 compared to current values (2020 = 1). Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                  </p>

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                    <Field label={t("scenario.labels.name", { defaultValue: "NAME" })}>
                      <input
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={liveScenarioName}
                        onChange={(e) => setLiveScenarioName(e.target.value)}
                        placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                        list="datalist-livestock"
                      />
                      <datalist id="datalist-livestock">
                        {liveProdNamesCustom.map((d) => (
                          <option key={d} value={d} />
                        ))}
                      </datalist>
                    </Field>
                    <Field label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}>
                      <Select
                        value={liveImplTiming}
                        onChange={setLiveImplTiming}
                        options={implOptions}
                        placeholder="Select implementation timing"
                      />
                    </Field>
                  </div>

                  <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                    {LIVESTOCK_FIELDS.map(({ key, label }) => (
                      <div key={key} className="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
                        <div className="flex items-center justify-between">
                          <div className="text-sm font-semibold text-slate-900">{label}</div>
                          <input
                            type="number"
                            min={0}
                            max={10}
                            step={0.1}
                            className="w-24 rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm outline-none focus:border-slate-400"
                            value={liveValues[key] ?? ""}
                            onChange={(e) =>
                              setLiveValues((prev) => ({
                                ...prev,
                                [key]: e.target.value,
                              }))
                            }
                            onBlur={(e) =>
                              setLiveValues((prev) => {
                                const rawValue = e.target.value;
                                const numericValue = Number(rawValue);
                                return {
                                  ...prev,
                                  [key]: rawValue === "" || !Number.isFinite(numericValue)
                                    ? LIVESTOCK_DEFAULT_VALUES[key]
                                    : String(Math.min(10, Math.max(0, numericValue))),
                                };
                              })
                            }
                          />
                        </div>
                        <input
                          type="range"
                          min={0}
                          max={10}
                          step={0.1}
                          className="mt-3 w-full"
                          value={clampNum(liveValues[key], 0, 10) ?? 1}
                          onChange={(e) =>
                            setLiveValues((prev) => ({
                              ...prev,
                              [key]: String(e.target.value),
                            }))
                          }
                        />
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 text-center">
                    <PrimaryButton onClick={submitLivestock} disabled={sendDisabled}>
                      {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                    </PrimaryButton>
                  </div>
                </section>
              )}

              {/* TAB 8: CROP PRODUCTIVITY */}
              {tab === 8 && (
                <section className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                  <h2 className="text-lg font-bold text-slate-900">
                    {t("scenario.crop.title", { defaultValue: "Crop Productivity Scenario" })}
                  </h2>
                  <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                    To create a Crop Productivity Scenario, type a name for it, set the implementation timing (how it reaches that value starting from 2025), and choose the expected productivity gap by 2050 (0% = no productivity gap, or maximum productivity per crop). Starting values correspond to the productivity gap in 2020. Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                  </p>

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                    <Field label={t("scenario.labels.name", { defaultValue: "NAME" })}>
                      <input
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={cropScenarioName}
                        onChange={(e) => setCropScenarioName(e.target.value)}
                        placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                        list="datalist-crop"
                      />
                      <datalist id="datalist-crop">
                        {cropProdNamesCustom.map((d) => (
                          <option key={d} value={d} />
                        ))}
                      </datalist>
                    </Field>
                    <Field label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}>
                      <Select
                        value={cropImplTiming}
                        onChange={setCropImplTiming}
                        options={implOptions}
                        placeholder="Select implementation timing"
                      />
                    </Field>
                  </div>

                  <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                    {CROP_FIELDS.map(({ key, label, defaultYield }) => (
                      <div key={key} className="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
                        <div className="flex items-center justify-between">
                          <div className="text-sm font-semibold text-slate-900">{label}</div>
                          <input
                            type="number"
                            min={0}
                            max={100}
                            step={1}
                            className="w-24 rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm outline-none focus:border-slate-400"
                            value={cropValues[key] ?? ""}
                            onChange={(e) =>
                              setCropValues((prev) => {
                                return {
                                  ...prev,
                                  [key]: e.target.value,
                                };
                              })
                            }
                            onBlur={(e) =>
                              setCropValues((prev) => {
                                const rawValue = e.target.value;
                                const numericValue = Number(rawValue);
                                return {
                                  ...prev,
                                  [key]: rawValue === "" || !Number.isFinite(numericValue)
                                    ? String(defaultYield)
                                    : String(Math.min(100, Math.max(0, numericValue))),
                                };
                              })
                            }
                          />
                        </div>
                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={1}
                          className="mt-3 w-full"
                          value={clampNum(cropValues[key], 0, 100) ?? defaultYield}
                          onChange={(e) =>
                            setCropValues((prev) => ({
                              ...prev,
                              [key]: String(Math.min(100, Math.max(0, Number(e.target.value)))),
                            }))
                          }
                        />
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 text-center">
                    <PrimaryButton onClick={submitCrop} disabled={sendDisabled}>
                      {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                    </PrimaryButton>
                  </div>
                </section>
              )}

              {/* TAB 5: AFFORESTATION */}
              {tab === 5 && (
                <section className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                  <h2 className="text-lg font-bold text-slate-900">
                    {t("scenario.afforestation.title", { defaultValue: "Afforestation Scenario" })}
                  </h2>
                  <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                    To create an Afforestation Scenario, type a name for it, set the area to be afforested by 2050 (in thousand ha) and choose the implementation timing (how it reaches that value starting from 2025). Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                  </p>

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
                    <Field label={t("scenario.labels.scenarioName", { defaultValue: "Scenario Name" })}>
                      <input
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={affName}
                        onChange={(e) => setAffName(e.target.value)}
                        placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                        list="datalist-aff"
                      />
                      <datalist id="datalist-aff">
                        {affNamesCustom.map((n) => (
                          <option key={n} value={n} />
                        ))}
                      </datalist>
                    </Field>

                    <Field
                      label={t("scenario.afforestation.targetArea2050", {
                        defaultValue: "Target afforested area by 2050 (1000 ha)",
                      })}
                    >
                      <input
                        type="number"
                        min={0}
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={affTarget}
                        onChange={(e) => setAffTarget(clampNum(e.target.value, 0, 100000000) ?? "")}
                        placeholder={t("scenario.placeholders.enterValue", { defaultValue: "Enter Value" })}
                      />
                    </Field>

                    <Field
                      label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}
                    >
                      <Select
                        value={affImplTiming}
                        onChange={setAffImplTiming}
                        options={implOptions}
                        placeholder="Select implementation timing"
                      />
                    </Field>
                  </div>

                  <div className="mt-6 text-center">
                    <PrimaryButton onClick={submitAfforestation} disabled={sendDisabled}>
                      {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                    </PrimaryButton>
                  </div>
                </section>
              )}

              {/* TAB 10: IRRIGATION */}
              {tab === 10 && (
                <section className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
                  <div className="mb-4">
                    <h2 className="text-lg font-bold text-slate-900">
                      {t("scenario.irrigation.title", { defaultValue: "Share of Irrigated Area Scenario" })}
                    </h2>
                    <p className="mt-3 rounded-2xl bg-slate-50/80 p-4 text-sm leading-6 text-slate-700">
                      To create an Irrigation Scenario, type a name for it, set the implementation timing (how it reaches that value starting from 2025) and choose the expected share of irrigated land for each crop group (in %). Starting values correspond to the 2020 average irrigation shares. Click on Create Scenario when you are done, then you can choose your scenario to create a new pathway.
                    </p>
                  </div>

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                    <Field label={t("scenario.labels.name", { defaultValue: "NAME" })}>
                      <input
                        className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
                        value={irrigationName}
                        onChange={(e) => setIrrigationName(e.target.value)}
                        placeholder={t("scenario.placeholders.enterName", { defaultValue: "Enter Name" })}
                        list="datalist-irrigation"
                      />
                      <datalist id="datalist-irrigation">
                        {irrigationNamesCustom.map((d) => (
                          <option key={d} value={d} />
                        ))}
                      </datalist>
                    </Field>
                    <Field label={t("scenario.labels.implTiming", { defaultValue: "Implementation Timing" })}>
                      <Select
                        value={irrigationImplTiming}
                        onChange={setIrrigationImplTiming}
                        options={implOptions}
                        placeholder="Select implementation timing"
                      />
                    </Field>
                  </div>

                  <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                    {IRRIGATION_FIELDS.map((field) => (
                      <div key={field} className="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
                        <div className="flex items-center justify-between">
                          <div className="text-sm font-semibold text-slate-900">
                            {IRRIGATION_LABELS[field] || field}
                          </div>
                          <div className="flex items-center gap-1">
                            <input
                              type="number"
                              min={0}
                              max={100}
                              step={1}
                              className="w-20 rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm outline-none focus:border-slate-400"
                              value={irrigationValues[field] ?? ""}
                              onChange={(e) =>
                                setIrrigationValues((prev) => ({
                                  ...prev,
                                  [field]: e.target.value,
                                }))
                              }
                              onBlur={(e) =>
                                setIrrigationValues((prev) => {
                                  const rawValue = e.target.value;
                                  const numericValue = Number(rawValue);
                                  return {
                                    ...prev,
                                    [field]: rawValue === "" || !Number.isFinite(numericValue)
                                      ? IRRIGATION_DEFAULT_VALUES[field]
                                      : String(Math.min(100, Math.max(0, numericValue))),
                                  };
                                })
                              }
                            />
                            <span className="text-sm text-slate-600">%</span>
                          </div>
                        </div>
                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={1}
                          className="mt-3 w-full"
                          value={clampNum(irrigationValues[field], 0, 100) ?? 0}
                          onChange={(e) =>
                            setIrrigationValues((prev) => ({
                              ...prev,
                              [field]: String(e.target.value),
                            }))
                          }
                        />
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 text-center">
                    <PrimaryButton onClick={submitIrrigation} disabled={sendDisabled}>
                      {sendDisabled ? scenarioBusyLabel : t("scenario.send", { defaultValue: "Create Scenario" })}
                    </PrimaryButton>
                  </div>
                </section>
              )}
            </>
          )}
        </div>
      </main>

      {FloatChat ? <FloatChat /> : null}
    </div>
  );
}

// ===== helpers =====
function normalizeScenarioData(payload) {
  const safe = payload || {};
  return {
    ...safe,
    topimports: Array.isArray(safe.topimports) ? safe.topimports : [],
    topexports: Array.isArray(safe.topexports) ? safe.topexports : [],
    initial_imports: Array.isArray(safe.initial_imports) ? safe.initial_imports : [],
    initial_exports: Array.isArray(safe.initial_exports) ? safe.initial_exports : [],
    Diets: safe.Diets && typeof safe.Diets === "object" ? safe.Diets : {},
    Irrigations: safe.Irrigations && typeof safe.Irrigations === "object" ? safe.Irrigations : {},
  };
}

function clampNum(v, min, max) {
  if (v === "" || v === null || typeof v === "undefined") return null;
  const n = Number(v);
  if (Number.isNaN(n)) return null;
  return Math.min(max, Math.max(min, n));
}

function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-slate-700">{label}</label>
      <div className="mt-2">{children}</div>
    </div>
  );
}

function PrimaryButton({ children, onClick, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center rounded-2xl px-6 py-3 text-lg font-semibold text-white shadow-lg transition ${disabled ? "cursor-not-allowed bg-slate-400" : "bg-[#1E5B4F]/90 hover:bg-[#1E5B4F]"}`}
    >
      {disabled ? (
        <span className="flex flex-col items-center gap-2 leading-none">
          <span className="inline-flex items-center gap-2">
            <svg
              className="h-4 w-4 animate-spin text-white"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.35" strokeWidth="3" />
              <path d="M12 3a9 9 0 0 1 9 9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
            </svg>
            <span>{children}</span>
          </span>
          <BusyProgressBar />
        </span>
      ) : (
        children
      )}
    </button>
  );
}

function BusyProgressBar() {
  return (
    <span className="flex w-40 items-center gap-1" aria-hidden="true">
      <span className="h-1 flex-1 animate-pulse rounded-full bg-white/35" />
      <span
        className="h-1 flex-1 animate-pulse rounded-full bg-white/55"
        style={{ animationDelay: "0.15s" }}
      />
      <span
        className="h-1 flex-1 animate-pulse rounded-full bg-white/75"
        style={{ animationDelay: "0.3s" }}
      />
    </span>
  );
}

function SimpleTable({ headers = [], rows = [] }) {
  return (
    <div className="mt-3 overflow-x-auto rounded-2xl ring-1 ring-slate-200">
      <table className="min-w-full bg-white text-sm">
        <thead className="bg-slate-50">
          <tr>
            {headers.map((h, i) => (
              <th key={i} className="px-3 py-2 text-left font-semibold text-slate-700">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, ri) => (
            <tr key={ri} className="border-t border-slate-100">
              {r.map((c, ci) => (
                <td key={ci} className="px-3 py-2 text-slate-700">
                  {c}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function SkeletonCard() {
  return (
    <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
      <div className="h-4 w-2/3 animate-pulse rounded bg-slate-200" />
      <div className="mt-3 h-3 w-full animate-pulse rounded bg-slate-100" />
      <div className="mt-2 h-3 w-5/6 animate-pulse rounded bg-slate-100" />
    </div>
  );
}